
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#e10708] via-[#c00607] to-[#a00506] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl font-bold text-white mb-6">
          Ready to Transform Your Practice's Technology?
        </h2>
        <p className="text-xl text-white/90 mb-12 leading-relaxed">
          Schedule a complimentary Strategic Risk Assessment and discover how we protect what matters most.
        </p>

        <Link
          to="/contact"
          className="inline-block bg-white text-[#e10708] px-12 py-5 rounded-lg text-xl font-bold hover:bg-gray-50 transition-all duration-300 shadow-2xl hover:shadow-white/30 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Get Started Today
        </Link>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-white/80">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-white text-lg"></i>
            <span>HIPAA-Certified</span>
          </div>
          <div className="w-1 h-1 bg-white/50 rounded-full"></div>
          <div className="flex items-center gap-2">
            <i className="ri-hospital-line text-white text-lg"></i>
            <span>Trusted by Healthcare Practices</span>
          </div>
        </div>
      </div>
    </section>
  );
}
